
export class EnderecoParmDTO {
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  municipio: string;
  estado: string;
  descricao: string;
  cep: string;
  googlePlaceId: string;
  googleEnderecoFormatado: string;
}